import { classnames } from 'Utils/classnames/classnames.utils';

const small = {
  thRoot: 'flex flex-col gap-10',
  thRecap: '',
  thAttendees: 'font-bold text-12',
  thAttendeesNumbers: 'font-bold text-sienna',
  thRooms: 'font-brand text-18 text-sienna',
  thAlert:
    'border-1 border-orange flex font-sans gap-10 items-center px-10 py-5 rounded-12 text-10 text-orange',
};

export const themes = {
  default: small,
  medium: small,
  large: {
    ...small,
    thRoot: classnames(small.thRoot, 'sm:flex-row sm:items-center sm:gap-20'),
    thRecap: classnames(small.thRecap, 'basis-full sm:basis-2/5'),
    thAttendees: classnames(small.thAttendees, 'text-12 md:text-14'),
    thRooms: classnames(small.thRooms, 'sm:text-20 md:text-24'),
    thAlert: classnames(small.thAlert, 'w-full sm:basis-3/5 sm:text-12 md:text-14'),
  },
};
